import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {ReactComponent as ErrorIcon} from "assets/img/picto-error-404.svg";
import CustomButton from "../../../../components/CustomButton";
import {Grid} from "@mui/material";
import {WmsTaskStatus} from "../../../../utils/WMSTaskStatus";

DeleteMissionModelModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleValid: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    missionModel: PropTypes.object.isRequired
};

function DeleteMissionModelModal({open, handleClose, handleValid, loading, missionModel}) {
    const [hasTasks] = useState(0 < missionModel?.wmsTasks.length)
    const [inProgressTaskCount, setInProgressTaskCount] = useState(0)
    const [idleTaskCount, setIdleTaskCount] = useState(0)

    useEffect(() => {
        if (missionModel && hasTasks) {
            setInProgressTaskCount(missionModel.wmsTasks.filter(task => WmsTaskStatus.IN_PROGRESS === task.status).length)
            setIdleTaskCount(missionModel.wmsTasks.filter(task => WmsTaskStatus.IDLE === task.status).length)
        }
    }, [hasTasks, missionModel]);

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.pickingMissionList.deleteModelModal.title"} />}
            subtitle={<FormattedMessage id={"wms.pickingMissionList.deleteModelModal.subtitle"} />}
            icon={<ErrorIcon />}
        >
            <Grid container direction={"column"} gap={"16px"}>
                <Grid container direction={"column"} gap={"8px"} color={"red"}>
                    {0 < inProgressTaskCount && (
                        <Grid item>
                            <FormattedMessage id={"wms.pickingMissionList.deleteModal.inProgressTaskCount"} values={{count: inProgressTaskCount}} />
                        </Grid>
                    )}
                    {0 < idleTaskCount && (
                        <Grid item>
                            <FormattedMessage id={"wms.pickingMissionList.deleteModal.idleTaskCount"} values={{count: idleTaskCount}} />
                        </Grid>
                    )}
                </Grid>

                <Grid container direction={"column"} gap={"8px"}>
                    <CustomButton
                        loading={loading}
                        disabled={loading}
                        fullWidth
                        color={"red"}
                        onClick={handleValid}>
                        <FormattedMessage id={"wms.pickingMissionList.deleteModelModal.button.delete"}/>
                    </CustomButton>
                    <CustomButton
                        fullWidth
                        color={"default"}
                        onClick={handleClose}>
                        <FormattedMessage id={"wms.pickingMissionList.deleteModelModal.button.cancel"}/>
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default DeleteMissionModelModal;